import React from 'react';
import image from '../../images/sok-tender.jpg';

export default function Activities() {
  return (
    <div
      className="width100 "
      style={{ margin: '20px 0 20px 40px', padding: '0 20px' }}
    >
      <div className="tender-box">
        <br />
        <h3 style={{ textAlign: 'center' }}>
          Sinergija znanja i novo zapošljavanje u konkurentnim MSP
        </h3>
        <img
          src={image}
          style={{ height: '500px', margin: '20px 0', width: '100%' }}
          alt="activities"
        ></img>
        <br />
        <p>
          Kompanije i mala i srednja preduzeća koja posluju u
          metalskoj/mašinskoj industriji Srbije i nalaze se u
          opštinama/gradovima III i IV grupe razvijenosti u Srbiji, mogu da
          konkurišu za različite vrste pomoći u okviru konkursa koji raspisuju
          Vojvodina Metal Cluster - VMC, Udruženje stručnih radnika socijalne
          zaštite Srbije i ENECA. Konkurs za biznise iz metalskog/mašinskog
          sektora raspisuje se u okviru projekta „ SoK-Sinergija znanja i novo
          zapošljavanje u konkurentnim MSP“, koji je podržala Kraljevina
          Norveška preko projekta „Norveška za vas – Srbija“ i otvoren je do 15.
          aprila 2021. godine.
        </p>
        <br />
        <label>
          <span className="tender-box-highlight ">Ko može da konkuriše?</span>
        </label>
        <br />
        <p>
          Firme iz metalskog/mašinskog sektora Srbije, registrovane u APR-u
          (preduzetnik, mikro, mala i srednja preduzeća. Neophodno je da se
          nalaze na teritoriji opština i gradova: Aleksinac, Trstenik, Brus,
          Kraljevo, Prokuplje, Kuršumlija, Boljevac, Ćuprija, Paraćin, Svrljig,
          Blace, Žitorađa, Soko Banja, Knjaževac i Despotovac.
          <br />
          Potrebno je da su već članovi Vojvodina Metal Clustera ili da su
          podneli prijavu za članstvo u klasteru. Ne smeju da budu u stečajnom
          ili likvidacionom postupku.
        </p>
        <br />
        <label>
          <span className="tender-box-highlight ">Kako se konkuriše?</span>
        </label>
        <p>
          Konkurs traje od 15. marta do 15. aprila 2021. godine u 15:00 sati.
          Poziv za podnošenje prijava, kao i prijavni formular mogu se preuzeti
          sa sajta VMC, dok sva pitanja u vezi sa procedurom prijavljivanja na
          konkurs možete postaviti putem e-maila: office@vmc.rs i na telefon
          063/755 8 305, radnim danom od 10 do 14 časova, zaključno sa 12.
          aprilom 2021.godine.
        </p>
        <br />
        <p>
          Popunjene prijavne formulare treba poslati isključivo elektronskim
          putem u PDF format (potpisana, pečatirana i skenirana) do 15. aprila
          2021. do 15:00 časova na el. adresu: office@vmc.rs.
        </p>
        <br />
        <p>Prijave koje pristignu nakon utvrđenog roka nede biti prihvaćene.</p>
        <br />
        <p>U subjectu mejla navesti: Prijavni formular – Naziv pravnog lica.</p>
        <br />
        <p>
          Prijave poslate na bilo koji drugi način (npr. faksom ili poštom) nede
          biti uzete u razmatranje.
        </p>
        <br />
        <p>
          Podnosilac prijave <span style={{ fontWeight: 'bold' }}>NE MOŽE</span>{' '}
          da podnese više od jedne prijave.
        </p>
        <br />
        <p>Rezultati Konkursa biće objavljeni 30. aprila 2021. godine.</p>
        <br />
        <label>
          <span className="tender-box-highlight ">
            Šta biznisi mogu da dobiju na Konkursu?
          </span>
        </label>
        <p>
          Učešće na poslovnim B2B susretima sa potencijalnim kupcima/partnerima,
          koji će biti organizovani u Nišu - za minimum 40 biznisa.
          Sertifikovanu obuku za interne proverivače sistema kvaliteta ISO – za
          najmanje. 5 biznisa. Obezbeđenje ISO standarda kvaliteta (npr. ISO
          9001,ISO 14000, CE–znak i dr.) za minimum 5 biznisa. Konsultantska
          podrška i učešće u programu podrške za razvoj i komercijalizaciju
          inovacija „VMC – Inovativni pul“- za najmanje 3 biznisa/inovacije.
          Konsultantska podrška kroz program podrške poslovanju „VMC Biznis
          klinika“ za minimum 5 biznisa. Sertifikovana obuka zavarivača prema
          stvarnim potrebama konkretnih kompanija za najmanje 5 biznisa.
          Sertifikovana obuka za CNC operatere prema stvarnim potrebama
          konkretnih kompanija za minimum 5 biznisa. Mentorska podrška u vidu
          treninga za poslodavce u domenu društvene odgovornosti i rada sa
          zaposlenima iz društveno osetljivih grupa za najmanje 30 biznisa.
        </p>
        <br />
        <label>
          <span className="tender-box-highlight ">
            Šta su obaveze podržanih biznisa?
          </span>
        </label>
        <p>
          Kompanija, malo ili srednje preduzeće ili preduzetnik koji bude
          podržan u obavezi je da aktivno učestvuju u realizaciji projektnih
          aktivnosti, kao i da obezbedi jedno lice za kontakte sa projektom i
          VMC-om. Osim toga, treba da omogući praksu za najmanje 1 nezaposleno
          lice u trajanju od jednog meseca, a troškovi obuke biće pokriveni od
          strane projekta, kao i da u toku realizacije projekta zaposli minimum
          jedno lice koje je prethodno bilo na praksi.
        </p>
        <br />
        <label>
          <span className="tender-box-highlight ">O projektu SoK</span>
        </label>
        <p>
          Projekat SoK - Sinergija znanja i novo zapošljavanje u konkurentnim
          MSP realizuju partneri Vojvodina Metal Klaster iz Temerina, ENECA iz
          Niša i Udruženje stručnih radnika socijalne zaštite Republike Srbije
          iz Beograda. Projekat podržava Kraljevina Norveška preko projekta
          „Norveška za vas – Srbija“.
          <br />
          <br /> &quot;{' '}
          <span style={{ fontWeight: 'bold' }}>
            Ova inovativna partnerska akcija tri respektabilne organizacije za
            podršku MSP koje deluju na nacionalnom nivou, će doprineti
            uravnoteženju socio-ekonomskog razvoja u Srbiji poboljšanjem
            poslovnog okruženja i potencijala lokalnih preduzeća u nerazvijenim
            područjima u cilju novog zapošljavanja i socijalne inkluzije
            marginalizovanih društvenih grupa
          </span>
          &quot;, poručuju iz VMC.
          <br />
          <br />
          Cilj projekta je da se poboljšaju poslovne performanse (tržišni
          potencijal, održivost i konkurentnost), kao i mogućnosti novog
          zapošljavanja u malim i srednjim preduzećima (MSP) metalskog/mašinskog
          sektora.
        </p>
        <br />
        <br />
        <label>
          Javni poziv i prijavu mozete preuzeti
          <a
            href="/files/Javni_poziv_i_prijava_SOK.zip"
            download
            className="font-weight-bold"
          >
            {' '}
            OVDE
          </a>
        </label>
      </div>
    </div>
  );
}
